export type SummaryExport = {
  title: string;
  summary: string;
  keyPoints: readonly string[];
};

export function formatSummaryText(
  content: SummaryExport,
  labels: { summary: string; keyPoints: string },
) {
  return [
    content.title.trim(),
    `${labels.summary}\n\n${content.summary.trim()}`,
    content.keyPoints.length > 0
      ? `${labels.keyPoints}\n\n${content.keyPoints.map((point) => `- ${point}`).join('\n')}`
      : '',
  ]
    .filter(Boolean)
    .join('\n\n');
}

export function formatSummaryCsv(
  content: SummaryExport,
  labels: { title: string; summary: string; keyPoints: string },
) {
  const cell = (value: string) => {
    const safeValue = /^[\s]*[=+@-]/u.test(value) ? `'${value}` : value;
    return `"${safeValue.replaceAll('"', '""')}"`;
  };
  return [
    [labels.title, labels.summary, labels.keyPoints],
    [content.title, content.summary, content.keyPoints.join('\n')],
  ]
    .map((row) => row.map(cell).join(','))
    .join('\r\n');
}

export function summaryExportFilename(title: string) {
  const name = Array.from(
    title
      .replaceAll(/[<>:"/\\|?*\p{Cc}]/gu, '-')
      .replaceAll(/\s+/gu, ' ')
      .trim(),
  )
    .slice(0, 50)
    .join('')
    .replaceAll(/[. ]+$/gu, '');
  return `${name || 'document'}-summary`;
}
